<template>
  <div>
    <!--  v-validate="'required|email|min:3'" -->
    <vs-input
        v-validate="'required'"
        data-vv-validate-on="blur"
        name="username"
        icon-no-border
        icon="icon icon-user"
        icon-pack="feather"
        label-placeholder="Username"
        v-model="username"
        class="w-full"/>
    <span class="text-danger text-sm">{{ errors.first('username') }}</span>
    <!-- v-validate="'required|min:6|max:10'" -->
    <vs-input
        data-vv-validate-on="blur"
        v-validate="'required'"
        type="password"
        v-on:keyup.enter="loginJWT"
        name="password"
        icon-no-border
        icon="icon icon-lock"
        icon-pack="feather"
        label-placeholder="Password"
        v-model="password"
        class="w-full mt-6" />
    <span class="text-danger text-sm">{{ errors.first('password') }}</span>

    <!-- <div class="flex flex-wrap justify-between my-5">
        <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Remember Me</vs-checkbox>
        <router-link to="/pages/forgot-password">Forgot Password?</router-link>
    </div> -->
    <div class="flex flex-wrap justify-between mb-3 my-5">
      <!-- <vs-button  type="border" @click="registerUser">Register</vs-button> -->
      <vs-button :disabled="!validateForm" @click="loginJWT">Login</vs-button>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      username: '',
      password: '',
      checkbox_remember_me: false,
      hasInternet: navigator.onLine,
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.username !== '' && this.password !== ''
    }
  },
  created () {
    let self = this
    sessionStorage.removeItem('loan_info')
    window.addEventListener('offline', function(e) { 
      self.hasInternet = false
      console.log('offline'); 
    });

    window.addEventListener('online', function(e) { 
      self.hasInternet = true
      console.log('online'); 
    });

    if(location.hostname == 'localhost'){
      this.username = 'developer'
      this.password = '888888'
    }
  },
  methods: {
    checkLogin () {
      // If user is already logged in notify
      if (this.$store.state.auth.isUserLoggedIn()) {

        // Close animation if passed as payload
        // this.$vs.loading.close()

        this.$vs.notify({
          title: 'Login Attempt',
          text: 'You are already logged in!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }
      return true
    },
    loginJWT () {

      if (!this.checkLogin()) return

      if(!this.hasInternet){
        this.$vs.notify({
          time:1500,
          title: 'Internet Connection',
          text: 'Unable to connect to internet.',
          iconPack: 'feather',
          icon: 'icon-alert-triangle',
          color: 'warning'
        })
        return false 
      } 
      // Loading
      this.$vs.loading()

      const payload = {
        // checkbox_remember_me: this.checkbox_remember_me,
        userDetails: {
          username: this.username,
          password: this.password
        }
      }

      this.$store.dispatch('auth/loginJWT', payload)
        .then(() => { 
          this.$vs.loading.close() 
          // this.$store.dispatch('customerManagement/fetchCustomers')
          // this.$store.dispatch('userManagement/fetchUsers')
          this.$vs.notify({
            time:1500,
            title: 'Login Successful',
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success'
          })
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    // registerUser () {
    //   if (!this.checkLogin()) return
    //   this.$router.push('/pages/register').catch(() => {})
    // }
  }
}

</script>

